(function(angular){
    'use strict';

    angular.module('onvio.setup').controller('EnableTermsConfirmModalCtrl', enableTerms);
    enableTerms.$inject = ['$uibModalInstance'];

    function enableTerms($uibModalInstance){
        /*jshint validthis:true */
        var vm = this;
        vm.saveConfirm = saveConfirm;
        vm.cancelConfirm = cancelConfirm;

        ///////////

        function saveConfirm(){
            closeModal(true);
        }

        function cancelConfirm(){
            closeModal(false);
        }

        function closeModal(isConfirmed){
            $uibModalInstance.close(isConfirmed);
        }
    }
})(window.angular);
